import src from "IMAGE";
export default { src, width: 332, height: 50, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABsnIy0bJiIsExsYISc4M0kfLSg5FR8cJRYfHCQWHxwlSxUEcTXnrbUAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
